import type { BotNewQuestionnaireWebSocket } from "@/Modules/Chat/Models/WebSocket";
import type { EventFilter } from "@/Modules/Chat/WebSocketManager";

import { MessageTypeWebSocket } from "@/Modules/Chat/Models/WebSocket";
import { useQuestionnaireStore, type QuestionnaireStore } from "@/Modules/Questionnaire/Store";

import { isObject } from "@/Utils/Objects";

export interface ExtraParamsNewQuestionnaire {
  questionnaireStore: QuestionnaireStore;
}

export const isQuestionnaireAnsweredType = (value: unknown): value is BotNewQuestionnaireWebSocket => {
  return isObject(value) && value.type === MessageTypeWebSocket.NEW_QUESTIONNAIRE && isObject(value.data);
};

export const questionnaireAnsweredHandler = async (
  _message: BotNewQuestionnaireWebSocket,
  { questionnaireStore = useQuestionnaireStore() }: ExtraParamsNewQuestionnaire
): Promise<undefined> => {
  await questionnaireStore.fetchQuestionnaireSummaries();
  await questionnaireStore.fetchQuestionnaires();

  return Promise.resolve(undefined);
};

export default {
  isType: isQuestionnaireAnsweredType,
  handler: questionnaireAnsweredHandler,
} as EventFilter<ExtraParamsNewQuestionnaire>;
